import {
  FormInputNumber,
  FormInputNumberProps,
} from '@moneyforward/ap-frontend-components';
import { memo } from 'react';
import { FieldValues } from 'react-hook-form';
import { CellProps } from './type';

export type Props<TFieldValues extends FieldValues> =
  {} & FormInputNumberProps<TFieldValues> & CellProps;

const InnerFormInputNumberCell = <TFieldValues extends FieldValues>({
  control,
  name,
  ...rest
}: Props<TFieldValues>) => {
  return (
    <FormInputNumber<TFieldValues> control={control} name={name} {...rest} />
  );
};
InnerFormInputNumberCell.displayName = 'FormInputNumberCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const FormInputNumberCell = memo(
  InnerFormInputNumberCell
) as typeof InnerFormInputNumberCell;
